import { stringRequiredSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const schoolDivisonFormSchema = object().shape({
  title: stringRequiredSchema,
  status: stringRequiredSchema,
});

export default schoolDivisonFormSchema;